import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function CTABand({
  eyebrow = 'Ready When You Are',
  title = "Let's clear your property fast.",
  subtitle = 'Photo-based quote, same-day response, donation-conscious every step.',
  ctaLabel = 'Get a Free Quote',
  ctaTo = '/contact',
}) {
  return (
    <section className="bg-ohana-primary text-ohana-bg" data-testid="cta-band">
      <div className="container-ohana py-16 md:py-20">
        <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="overline">{eyebrow}</p>
            <h2 className="font-serif text-4xl md:text-5xl mt-3 leading-tight tracking-tight">
              {title}
            </h2>
            <p className="mt-5 text-ohana-bg/75 text-base md:text-lg leading-relaxed">
              {subtitle}
            </p>
          </div>
          <Link to={ctaTo} className="btn-primary self-start" data-testid="cta-band-button">
            {ctaLabel}
            <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
